import actionTypes from '../constants/action-types';
import saving from '../../saving';

const assets = (state = [], action) => {
  switch (action.type) {
    case actionTypes.MAKE_ASSET_PUBLISHABLE: {
      let targetAsset = state.find((asset) => asset.source === action.payload.source);
      let restAssets = state;

      if (targetAsset) {
        restAssets = state.filter((asset) => asset.source !== action.payload.source);
      } else {
        targetAsset = {
          source: action.payload.source,
        };
      }

      return [
        ...restAssets,
        {
          ...targetAsset,
          publishable: true,
        },
      ];
    }
    case saving.actionTypes.SET_STATUS: {
      if (action.payload.status === 'SAVED') {
        return [];
      }

      return state;
    }
    default:
      return state;
  }
};

export default assets;
